import { type BaseRendererComponentProps, type ModelCreator, BaseModelProps, LocalStorageStore, ReactRenderer } from '@mail/3promo';
import React from 'react';
import { IS_MY_TEAM, IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { PROMO_ID } from 'reactApp/appHelpers/featuresHelpers/features/vigboPrintFakedoor';
import { BannerModel } from 'reactApp/modules/promoNew/models/bannerModel';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { isFakedoorCompleted } from 'reactApp/ui/VigboPrintFakedoor/utils';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';

const LazyComponent = React.lazy(() => import('reactApp/ui/VigboPrintFakedoor/VigboPrintBanner/VigboPrintBanner'));

const SuspendedComponent = <P extends BaseRendererComponentProps>(props: P) => {
    return (
        <React.Suspense fallback={null}>
            <LazyComponent {...props} />
        </React.Suspense>
    );
};

const sendRadar = createDwhTemplatedSender({ eventCategory: 'vigbo_banner', replacementSymbol: '_' });

export const vigboPrintBannerCreator: ModelCreator = ({ models, render, stores }) =>
    new BannerModel(
        PROMO_ID,
        models.base,
        new BaseModelProps(PROMO_ID, {
            store: new LocalStorageStore(PROMO_ID, stores.localStorage),
            renderer: new ReactRenderer(PROMO_ID, SuspendedComponent, render.react),
            closable: true,
            closeLimit: 1,
            templateData: {},
            ignorePromoShowInterval: true,
            ignoreTestOnRedraw: false,
            // Отправляем аналитику тут, так как баннер может закрыться при уходе с хомяка
            onShow: () => {
                sendRadar({
                    action: 'fakedoor_show',
                });
            },
            onHide: () => {
                sendRadar({
                    action: 'fakedoor_close',
                });
            },
            onComplete: () => {
                sendRadar({
                    action: 'fakedoor_click',
                });
            },
            test: (resolve, reject) => {
                const state = reduxStore.getState();
                const isBizUser = UserSelectors.isBizUser(state);
                const storage = getCurrentStorage(state);

                // Закомплитили фейкдор через другие промки
                if (isFakedoorCompleted()) {
                    reject();
                    return;
                }

                // Только десктоп веб
                if (IS_PHONE_BROWSER || IS_MY_TEAM) {
                    reject();
                    return;
                }

                // Не показываем бизам
                if (isBizUser) {
                    reject();
                    return;
                }

                // Показываем только в хомяке
                if (storage !== EStorageType.home) {
                    reject();
                    return;
                }

                resolve();
            },
        })
    );
